import { useDispatch } from 'react-redux';
import { Data } from 'signup-constants/signupData/Data';
import { EndpointKey } from '../http/EndpointKey';
import imageUrls from '../images/imageUrls';
import { useSignupData } from '../signup-data/useSignupData';
import { CheckYourEmailMessage } from '../step-check-your-email/CheckYourEmailMessage';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const VerifyFirstCreationError = () => {
  const {
    data: email
  } = useSignupData(Data.Email);
  const dispatch = useDispatch();
  const errorKey = ErrorKey.VerifyFirstCreationError;
  const onClick = event => {
    event.preventDefault();
    dispatch(retryEndpoint(EndpointKey.Signup));
  };
  const renderContent = () => {
    return /*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockStart: "800",
      children: /*#__PURE__*/_jsx(CheckYourEmailMessage, {
        email: email
      })
    });
  };
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    imageURL: imageUrls.email,
    renderContent: renderContent,
    onSentenceWithLinkClick: onClick
  });
};
export default VerifyFirstCreationError;